import { render } from "./ISearchOrganisationPicker.vue?vue&type=template&id=a921098a"
import script from "./ISearchOrganisationPicker.vue?vue&type=script&lang=js"
export * from "./ISearchOrganisationPicker.vue?vue&type=script&lang=js"

import "./ISearchOrganisationPicker.vue?vue&type=style&index=0&id=a921098a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__